<template>
  <v-dialog persistent width="480" v-model="active">
    <v-card>
      <v-card-title>Perfil de acceso</v-card-title>
      <v-card-text>
        <div class="text-body-2 mb-4">
          El usuario ingresado cuenta con varios perfiles en el sistema. ¿Con qué perfil desea entrar?
        </div>
        <v-list-item v-for="(perfil, index) in perfilesFiltrados" :key="index" link @click="enterApp(perfil)">
          <v-list-item-content>
            <v-list-item-title class="text-subtitle-1 font-weight-bold">{{ perfil }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <div v-if="perfilesFiltrados.length === 0" class="text-center text-body-2 grey--text">
          No se encontraron perfiles válidos para este usuario.
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import { PERFILES } from '@/perfiles.js'

export default {
  props: {
    active: {
      type: Boolean,
    },
  },
  data() {
    return {
      PERFILES,
    }
  },

  computed: {
    ...mapGetters({
      perfiles: 'getLoginPerfiles',
      idPersonal: 'getIdPersonal',
    }),

    perfilesFiltrados() {
      const perfilesValidos = Object.values(this.PERFILES)

      const perfilesFiltradosPorValidos = this.perfiles.filter((perfil) => perfilesValidos.includes(perfil))
      return [...new Set(perfilesFiltradosPorValidos)]
    },
  },

  methods: {
    ...mapMutations(['SET_PERFIL']),

    enterApp(perfil) {
      this.$emit('close')
      localStorage.setItem('perfil', perfil)
      this.SET_PERFIL(perfil)
      switch (perfil) {
        case this.PERFILES.Armeria:
          window.location.replace('armeria/inventario_armas')
          break
        case this.PERFILES.Equipamiento:
          window.location.replace('equipamiento/personal')
          break
        case this.PERFILES.Profesionalización:
          window.location.replace('profesionalizacion/dashboard')
          break
        case this.PERFILES['Personal / Site']:
          window.location.replace('personal/dashboard')
          break
        case this.PERFILES['Recursos Humanos']:
          window.location.replace('recursos_humanos/dashboard')
          break
        case this.PERFILES['Enlace C3']:
          window.location.replace('enlace_c3/dashboard')
          break
        case this.PERFILES['Administrador IPH+']:
          window.location.replace('launcher')
          break
        case this.PERFILES['Asuntos Internos']:
          window.location.replace('asuntos_internos/personal')
          break
        case this.PERFILES['Consejo de Honor y Justicia']:
          window.location.replace('asuntos_internos/personal')
          break
        case this.PERFILES.Policia:
          window.location.replace('policia/' + this.idPersonal)
          break

        // * Nuevos perfiles
        case this.PERFILES.IFCSP_PROFESIONALIZACION:
          window.location.replace('profesionalizacion/dashboard')
          break
        case this.PERFILES.IFCSP_RECLUTAMIENTO:
          window.location.replace('profesionalizacion/dashboard')
          break
        case this.PERFILES.IFCSP_ADMINISTRADOR:
          window.location.replace('profesionalizacion/dashboard')
          break
        case this.PERFILES.REP_ADMINISTRADOR:
          window.location.replace('personal/dashboard')
          break
        case this.PERFILES.REP_REGISTRO:
          window.location.replace('personal/dashboard')
          break
        case this.PERFILES.REP_CREDENCIALIZACION:
          window.location.replace('personal/dashboard')
          break
        case this.PERFILES.REP_BIOMETRIA:
          window.location.replace('personal/dashboard')
          break
        case this.PERFILES['ENLACE C3_CAPTURA DE RESULTADOS']:
          window.location.replace('enlace_c3/dashboard')
          break
        case this.PERFILES['ENLACE C3_CAPTURA DE EXPEDIENTE']:
          window.location.replace('enlace_c3/dashboard')
          break
        case this.PERFILES['ENLACE C3_ADMINISTRADOR']:
          window.location.replace('enlace_c3/dashboard')
          break
        case this.PERFILES.RH_ADMINISTRADOR:
          window.location.replace('recursos_humanos/dashboard')
          break
        case this.PERFILES['RH_TRAMITES ADMINISTRATIVOS']:
          window.location.replace('recursos_humanos/dashboard')
          break
        case this.PERFILES['RH_CAMBIO DE ESTATUS/ADSCRIPCION']:
          window.location.replace('recursos_humanos/dashboard')
          break
        case this.PERFILES['RH_REGISTRO DE PERSONAL']:
          window.location.replace('recursos_humanos/dashboard')
          break
        case this.PERFILES['ARMERIA_PASE DE LISTA']:
          window.location.replace('armeria/inventario_armas')
          break
        case this.PERFILES.ARMERIA_LOC:
          window.location.replace('armeria/inventario_armas')
          break
        case this.PERFILES['ARMERIA_PERSONAL LOC']:
          window.location.replace('armeria/inventario_armas')
          break
        case this.PERFILES['ARMERIA_CATALOGOS E INVENTARIO ARMAS']:
          window.location.replace('armeria/inventario_armas')
          break
        case this.PERFILES['ARMERIA_CATALOGOS E INVENTARIO ACCESORIOS']:
          window.location.replace('armeria/inventario_armas')
          break
        case this.PERFILES.EQUIPAMIENTO_ADMINISTRADOR:
          window.location.replace('equipamiento/personal')
          break
        case this.PERFILES.DP_ADMINISTRADOR:
          window.location.replace('desarrollo_profesional/personal')
          break
        case this.PERFILES.DP_EVALUACIONES:
          window.location.replace('desarrollo_profesional/personal')
          break
        case this.PERFILES.DP_CONVOCATORIAS_CONDECORACIONES:
          window.location.replace('desarrollo_profesional/personal')
          break
        default:
          console.log('Perfil no reconocido:', perfil)
          break
      }
    },
  },
}
</script>
